import APIAdmin from '@/api/modules/admin';

export default {
  namespaced: true,
  state: () => ({
    admin: null,
  }),
  mutations: {
    SET_ADMIN(state, data) {
      state.admin = data;
    },
  },
  actions: {
    getAdmin({ commit, state }) {
      if (state.admin) return Promise.resolve(state.admin);
      return APIAdmin.getAdmin()
        .then((response) => {
          commit('SET_ADMIN', response.data || null);
          return response.data;
        })
        .catch(() => {
          commit('SET_ADMIN', null);
          return null;
        });
    },
  },
  getters: {
    fullName(state) {
      const a = state.admin && state.admin.admin;
      if (!a || !a.name) return '';
      return a.name.en || a.name.ru || '';
    },
    email(state) {
      return (state.admin && state.admin.admin && state.admin.admin.email) || '';
    },
    avatar(state) {
      const img = state.admin && state.admin.admin && state.admin.admin.image;
      if (!img) return '';
      return img.startsWith('//') ? `https:${img}` : img;
    },
  },
};
